<template>
    <div class="gh-page gh-page-summit" sticky-container>
        <gh-form-upgrade class="bg-pale-grey" />
        <gh-sponsors class="bg-white" :optionalStyle="'background-color: white;'"/>
    </div>
</template>

<script>
    import forceRerender from '@/mixins/forceRerender'
    import ghUpgradeHeader from '@/modules/events/suicidePreventionSummit/components/UpgradeHeader'
    import ghFormUpgrade from '@/modules/events/suicidePreventionSummit/components/FormUpgrade'
    import ghSponsors from '@/modules/events/suicidePreventionSummit/components/Sponsors'

    export default {
        mixins: [forceRerender],

        components: {
            ghUpgradeHeader,
            ghFormUpgrade,
            ghSponsors
        }
    }
</script>

<style lang="scss" src="~/sass/pages/landing/summit.scss">
    @import url('https://fonts.googleapis.com/css?family=Catamaran');
</style>
<style lang="scss" scoped>
    .ghBanner {
        background: #F2F2F2;
    }
    .bg-white {
        background-color: white;
    }
</style>
